
/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */


import { useEffect, useState } from "react";

// react-router-dom components
// import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
// import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useDispatch, useSelector } from "react-redux";
import { signUp, signIn } from "Redux/actions/user";
import { useNavigate } from "react-router-dom";

function Basic() {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(state => state.user);

  const [fromData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",

  })
  // console.log(user)
  const handleChange = (e) => {
    // console.log(e.target)
    setFormData({ ...fromData, [e.target.name]: e.target.value })
  }
  // console.log(fromData)
  const handleSubmit = async () => {
    if (show) {
      await dispatch(signUp(fromData, navigate))
    }
    else {
      await dispatch(signIn(fromData.email, fromData.password, navigate))
    }


  }
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            {show ? "Sign up" : "Sign in"}
          </MDTypography>
          <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <FacebookIcon color="inherit" />
              </MDTypography>
            </Grid>
            {/* <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GitHubIcon color="inherit" />
              </MDTypography>
            </Grid> */}
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GoogleIcon color="inherit" />
              </MDTypography>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            {show &&
              <>
                <MDBox mb={2}>
                  <MDInput onChange={(e) => handleChange(e)} type="name" name="name" label="Name" fullWidth />
                </MDBox>
                <MDBox mb={2}>
                  <MDInput onChange={(e) => handleChange(e)} type="phone" name="phone" label="Phone" fullWidth />
                </MDBox>
              </>
            }
            <MDBox mb={2}>
              <MDInput onChange={(e) => handleChange(e)} type="email" name="email" label="Email" fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDInput onChange={(e) => handleChange(e)} type="password" name="password" label="Password" fullWidth />
            </MDBox>
            {/* <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>
            </MDBox> */}
            <MDBox mt={4} mb={1}>
              <MDButton onClick={() => handleSubmit()} variant="gradient" color="info" fullWidth>
                {show ? "Sign up" : "Sign in"}
              </MDButton>
            </MDBox>
            <MDBox mt={1} mb={1} textAlign="center">
              <MDTypography variant="button" fontWeight="bold" color="error">
                {user?.error}
              </MDTypography>
            </MDBox>
            {/* <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Don&apos;t have an account?{" "}
                <MDTypography onClick={() => setShow(!show)}
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                  sx={{ cursor: "pointer", userSelect: "none" }}
                >
                  {show ? "Sign in" : "Sign up"}
                </MDTypography>
              </MDTypography>
            </MDBox> */}
          </MDBox>

        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
